'use client'

import Image from 'next/image'
import Link from 'next/link'
import { FadeIn } from '@/app/components/FadeIn'
import { ArrowLeft } from 'lucide-react'
import { ShopDetails } from './shopdetails'
import BackToTopButton from '@/app/services/Backtotop'
import ProjectMedia from './ProjectMedia'

export default function ShopProjectsPage() {
  const projects = Object.entries(ShopDetails).map(([id, project]) => ({
    id,
    title: project.title,
    media: project.mainMedia,
    href: `/services/shop-fitout/detail/${id}`,
  }))

  return (
      <main className="relative min-h-screen overflow-hidden">
      {/* 视频背景 */}
        <div
    className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
    style={{ backgroundImage: "url('/hk/hk8.webp')" }}
  />
      {/* 可选叠加层增强文字可读性 */}
      <div className="absolute top-0 left-0 w-full h-full bg-black/50" />

      {/* 页面内容 */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-8 py-10">
        <Link
          href="/"
          className="inline-flex items-center gap-2 bg-gray-100/80 text-gray-900 px-3 py-1 rounded-lg mb-6 hover:bg-gray-200 transition"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold mb-10 text-white text-center">
          Shop-fitout Projects
        </h1>
        <p className="text-gray-800 bg-white/70 mb-10 gap-y-3 p-6 rounded-lg font-Ovo text-lg leading-relaxed">
          Simoom is a <strong>Queensland-based shop fit-out builder specialising in restaurants, cafes, and retail spaces.</strong> We specialise in delivering tailored interior construction solutions with quality finishes and efficient project delivery. While we are not a design firm, we work closely with approved plans and can accommodate customised adjustments during construction.
         <br></br>
          <br></br>
          Our shop fit-out services include:
          <br></br>
          - <strong>Custom joinery, cabinetry, and built-in fixtures</strong>
          <br></br>
          - <strong>Feature lighting, flooring, and interior finishes</strong>
          <br></br>
          - Coordination with designers, suppliers, trades, and regulatory requirements
          <br></br>
          - Project management to ensure timelines and budgets are met
         <br></br>
         <br></br>
          As a local builder, we provide functional, durable, and modern shop fit-outs for hospitality and retail businesses across Queensland. Explore our projects to see our approach to design and craftsmanship.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {projects.map((project, i) => (
            <FadeIn key={project.id} y={20} delay={i * 0.1}>
              <Link
                href={project.href}
                className="block bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition"
              >
                <div className="relative w-full aspect-video">
                  <ProjectMedia
                    media={project.media}
                    alt={project.title}
                  />
                </div>

                <div className="p-4 text-gray-900 font-semibold text-lg text-center">
                  {project.title}
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </div>

      <BackToTopButton />

      <footer className="w-full text-center text-sm text-gray-700 py-8 mt-10 bg-white/80 backdrop-blur-md">
        <div className="space-y-2 font-Ovo">
          <p>Phone: 0450 226 877</p>
          <p>Address: 29 Brandl Street, Eight Mile Plains QLD 4113</p>
          <p>QBCC: 15234304 | ABN: 91 644 460 917</p>
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Simoom Construction. All rights reserved.
          </p>
        </div>
      </footer>
    </main>
  )
}









